module.exports = __webpack_public_path__ + "static/media/assigned.43579ac2.svg";